import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { DataStatus } from '@repo/ui/utils'

import { TaskWithBeneficiary } from '@/store/dashboard-tasks/types'

import { AsyncThunkConfig, RejectValue } from '../actions'

export const getDashboardTasks = createAsyncThunk<TaskWithBeneficiary[], void, AsyncThunkConfig>(
  'GET_DASHBOARD_TASKS',
  async (_, { getState, extra, rejectWithValue, fulfillWithValue }) => {
    const state = getState()
    const organizationId = state.user.currentOrganizationId
    if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)
    const caseWorker = getState().user.caseWorker
    if (!DataStatus.isFulfilled(caseWorker)) return rejectWithValue(RejectValue.NoCaseWorker)

    const res = await extra.altApi.dashboardTasks.getAll({
      organizationId,
      caseWorkerId: caseWorker.id,
    })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue(res)
  },
)
